<template>
  <div>
    <el-dialog
      title="子分区"
      center
      :visible="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="onClose"
      width="661px"
    >
      <el-table
        :data="zoneList"
        border
        size="small"
        :style="
          $bizutil.hasAnyPrivilege(['zone']) ? 'width: 1401px' : 'width: 1181px'
        "
      >
        <el-table-column prop="id" label="ID" align="center" width="70">
        </el-table-column>

        <el-table-column label="合区状态" align="center" width="140">
          <template slot-scope="scope">
            <span>{{
              scope.row.isMerging
                ? scope.row.mergingIntoZoneId == 0
                  ? "合区中..."
                  : "正在合入" + scope.row.mergingIntoZoneId + "区..."
                : ""
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="name"
          label="名称"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column label="被冠名" align="center" width="60">
          <template slot-scope="scope">
            <span>{{ scope.row.isNamedByPlayer ? "是" : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标记为新区" align="center" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.isNew ? "是" : "" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="$bizutil.hasAnyPrivilege(['zone'])"
          label="操作"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span
              class="link-button"
              @click="deleteZone(scope.row.id, scope.row.name)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openEditZoneDialog(false, scope.row)"
              >修改</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

import EditZoneDialog from "./EditZoneDialog";

// 本弹窗名称
const DialogName = "ChildZoneListPageDialog";

export default {
  data() {
    return {
      masterZoneId: 0,
      zoneList: [], // 分区列表数据

      sortData: {
        order: "",
        prop: "",
      },
    };
  },

  async created() {
    this.masterZoneId = dialogutil.getData(DialogName).masterZoneId;

    await this.loadChildZoneList();
  },

  components: {
    EditZoneDialog,
  },

  methods: {
    /**
     * 查询子分区集合
     */
    async loadChildZoneList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getChildZones`,
          { id: this.masterZoneId },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.zones || [];

      // 排序（按分区id倒序排列）
      listInResponse.sort((x, y) => {
        return y.id - x.id;
      });

      this.zoneList = listInResponse;
    },
    /**
     * 删除一个分区
     * @param {*} id
     * @param {*} name
     */
    async deleteZone(id, name) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除分区“${name}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/deleteZone`,
            {
              id: id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.zoneList.length; i++) {
          if (this.zoneList[i].id == id) {
            this.zoneList.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    async openEditZoneDialog(isCreate, oldData) {
      this.$dialogutil.open("EditZoneDialog", {
        closedCallback: () => {
          this.loadChildZoneList();
        },
        data: {
          value: {
            isCreate: isCreate,
            oldData: oldData,
          },
        },
      });
    },

    /**
     * “编辑分区”对话框关闭了
     */
    async onEditZoneDialogClosed() {
      this.shouldEditZoneDialogVisible = false;

      // 重新拉取分区集合
      return this.loadChildZoneList(this.masterZoneId);
    },

    ms2day(ts) {
      return util.ms2day(ts);
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>

<style lang="scss" scoped>
.zone-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.zone-status-tag-maintained {
  background-color: lightgray;
  border-color: lightgray;
}

.zone-status-tag-idle {
  background-color: chartreuse;
  border-color: chartreuse;
}

.zone-status-tag-full {
  background-color: rgb(243, 159, 159);
  border-color: red;
}

.el-icon-round {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>